import { isMaximumGreaterThanMinimum } from '@seek/salary-data';

import type { GetMinMaxAndAllowablesResult } from 'src/app/v1/views/components/Pay/util/getMinMaxAndAllowables';

export const deduceMaxSalaryTextError = (
  err: string,
  {
    minimum,
    maximum,
  }: Pick<GetMinMaxAndAllowablesResult, 'minimum' | 'maximum'>,
  salaryErrorMax?: string,
) => {
  if (!isMaximumGreaterThanMinimum({ minimum, maximum })) {
    return err;
  }
  if (salaryErrorMax === err) {
    return null;
  }
  return null;
};
